import dataService from "@/endpoints/dataService";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchIngestionTime = createAsyncThunk<
  Record<string, string>,
  { markets: number[] },
  { rejectValue: string }
>("ingestion/fetchIngestionTime", async ({ markets }, thunkAPI) => {
  try {
    const response: Record<string, string> =
      (await dataService.getIngestionTime(markets)) as any;
    return response;
  } catch (err: any) {
    return thunkAPI.rejectWithValue(
      "Fetching ingestion time failed " + err.message
    );
  }
});
